import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import store from './store'
import { Provider } from 'react-redux'
import { ClerkProvider } from '@clerk/clerk-react';
import { ClerkTokenBridge } from './auth/ClerkTokenBridge.tsx';

const PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ClerkProvider publishableKey={PUBLISHABLE_KEY} forceRedirectUrl="/realtime">
    <Provider store={store}>
      <ClerkTokenBridge />
      <App />
    </Provider>
  </ClerkProvider>
);

reportWebVitals();
